/**
 * This is an extension to Leaflet allowing to display TomTom traffic flow layer. It is based on  the raster L.TileLayer
 * implementation. The possible options are described below.
 *
 * @module Map
 * @class TomTomTrafficFlowLayer
 * @extends L.TileLayer
 */
/**
 * @method tomTomTrafficFlowLayer
 * @param {Object} [options] All the options that Leaflet allows, as described here:
 *     http://leafletjs.com/reference.html#tilelayer-options Additional options, which are TomTom specific, are
 *     described below.
 * @param {String} [options.style="absolute"] The traffic flow style to be displayed. It should be set to one of the following
 *     values: &lt;'absolute', 'relative', 'relative-delay'&gt;. By default, the _absolute_ style is used. When the
 *     style is set to _absolute_, then the colours of the road segments reflect a measured absolute speed. Calls using
 *     the _relative_ style return a speed relative to the free-flow traffic information, highlighting areas of
 *     congestion. The _Relative-delay_ style displays relative speeds only in places where they are different from
 *     the free-flow speed (no green segments shown).
 * @param {Number} [options.opacity=0.7] The traffic flow layer's opacity, by default set to 70%. A floating point
 *     value between 0 and 1 have to be used, where 1 means no transparency.
 * @param {Integer} [options.refresh=180000] The traffic flow information changes and needs to be reloaded
 *     periodically. By default, it is reloaded every 3 minutes. This parameter's value represents time in ms between
 *     refreshes. In order to disable reloading, set it to _false_ or _0_.
 */
define('display/layers/trafficFlowLayer',['leaflet', 'security', 'http', 'endpoints', './animator', './optionsComplementor'],
    function(L, security, http, endpoints, animator, optionsComplementor) {
        'use strict';

        var trafficFlowStyles = ['absolute', 'relative', 'relative-delay'];

        function getTrafficFlowStyle(trafficFlowLayer) {
            var style = 'absolute', i;
            if (typeof trafficFlowLayer === 'string') {
                for (i = 0; i < trafficFlowStyles.length; i += 1) {
                    if (trafficFlowStyles[i] === trafficFlowLayer.toLowerCase()) {
                        return trafficFlowStyles[i];
                    }
                }
            }
            return style;
        }

        function tileSizeEstimator(options) {
            return options.detectRetina && L.Browser.retina ? 512 : 256;
        }

        L.TomTomFlowLayer = L.TileLayer.extend({
            options: {
                attribution: '',
                minZoom: 2,
                maxZoom: 18,
                subdomains: 'abcd',
                reuseTiles: true,
                opacity: 0.7,
                style: 'absolute',
                refresh: 180000,
                errorTileUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAAB9JREFUGBntwQENAAAAwiD7p34ON2AAAAAAAAAAAOcCIQAAAfWivQQAAAAASUVORK5CYII=',
                detectRetina: false
            },
            name: 'trafficFlow',
            initialize: function(options) {
                var key, that;
                options = L.setOptions(this, options);
                if (options.bounds) {
                    options.bounds = L.latLngBounds(options.bounds);
                }
                security.setKey('services/trafficFlow', options.key);
                key = security.getKey('services/trafficFlow');
                options.accessToken = key;
                this._url = http.protocol() + '://' + endpoints.trafficFlowLayer + (key ? '?key={accessToken}' : '');
                options.style = getTrafficFlowStyle(options.style);
                optionsComplementor.fillInSubdomainsOptions(options);
                optionsComplementor.fillInTiles512Options(options, tileSizeEstimator);
                this.setOpacity(options.opacity);
                that = this;
                if (options.refresh) {
                    setInterval(function() {
                        that.redraw();
                    }, options.refresh);
                }
            },
            onAdd: function(map) {
                L.TileLayer.prototype.onAdd.call(this, map);
                if (this._animated) {
                    this.on('load', animator.loadAnimationFactory(this));
                }
                this._updateOpacity();
            }
        });

        L.tomTomFlowLayer = function(options) {
            return new L.TomTomFlowLayer(options);
        };

        return L.tomTomFlowLayer;
    });

